class CartRewardsBar extends HTMLElement {
  constructor() {
    super();
    this.isRendered = false;
  }

  connectedCallback() {
    if (!this.isRendered) {
      this.initData();
      this.render();
      this.isRendered = true;
    }
    
    // 绑定事件
    this.handleUpdate = this.handleUpdate.bind(this);
    window.addEventListener('cart:updated', this.handleUpdate);
    this.fetchCart();
  }

  disconnectedCallback() {
    window.removeEventListener('cart:updated', this.handleUpdate);
  }

  initData() {
    // 1. 解析 JSON 数据
    try {
      this.tiers = JSON.parse(this.getAttribute('data-tiers'));
      // 按数量从小到大排序，防止配置错误
      this.tiers.sort((a, b) => a.q - b.q);
    } catch (e) {
      console.error('Rewards Bar: Invalid Config', e);
      this.tiers = [];
    }

    this.msgs = {
      progress: this.getAttribute('msg-progress'),
      done: this.getAttribute('msg-done')
    };

    // 2. 计算最大刻度 (为了视觉美观，最大值是最后一个阶梯的 1.1 倍)
    const maxTier = this.tiers.length > 0 ? this.tiers[this.tiers.length - 1].q : 10;
    this.maxScale = maxTier * 1.1;
  }

  render() {
    // 公用图标
    const iconSvg = `<svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M20 7h-3.14l-2.09-4.18A2 2 0 0 0 12.97 2h-1.94a2 2 0 0 0-1.8 1.1L7.14 7H4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zm-9-3h1.94l2.09 4.18c.08.16-.04.32-.21.32H11V4zM4 9h7v11H6a1 1 0 0 1-1-1V9zm14 11h-5V9h7v9a1 1 0 0 1-1 1z"/></svg>`;

    // 动态生成节点 HTML Loop
    const nodesHtml = this.tiers.map((tier, index) => {
      const leftPos = (tier.q / this.maxScale) * 100;
      // 默认给所有节点加上 is-hidden，除非是第一个
      const initialClass ='is-hidden';
      
      return `
        <div class="cr-node ${initialClass}" data-idx="${index}" data-q="${tier.q}" style="left: ${leftPos}%">
          <div class="cr-bubble">${tier.l}</div>
          <div class="cr-icon">${iconSvg}</div>
        </div>
      `;
    }).join('');

    this.innerHTML = `
      <style>
        cart-rewards-bar { display: block; padding: 15px 20px; background: #fff; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.05); margin: 10px 0; font-family: inherit; --h-color: #000;position:relative; }
        .cr-header { text-align: center; margin-bottom: 24px;height:45px; }
        .cr-msg { font-size: 14px; color: #333; margin: 0; font-weight: 500; }
        .cr-bold { font-weight: 700; color: var(--h-color); }
        
        .cr-track { position: relative; height: 10px; margin-top: 15px; }
        .cr-bg { position: absolute; width: 100%; height: 100%; background: var(--cr-bg); border-radius: 10px; }
        .cr-fill { position: absolute; height: 100%; background: var(--cr-primary); border-radius: 10px; width: 0%; transition: width 0.5s ease; }
        .cr-glow { position: absolute; right: 0; top: 0; height: 100%; width: 20px; background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4)); border-radius: 0 10px 10px 0; }

        .cr-node { position: absolute; top: 50%; transform: translate(-50%, -50%); display: flex; flex-direction: column; align-items: center; transition: all 0.4s ease; z-index: 2;}
        .cr-icon { width: 24px; height: 24px; background: var(--cr-primary); border: 2px solid #fff; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #fff; box-shadow: 0 0 0 1px var(--cr-primary); transition: all 0.3s ease; }
        .cr-bubble { position: absolute; bottom: 26px; background: #fff; border: 1px solid var(--cr-primary); color: #333; padding: 2px 8px; border-radius: 10px; font-size: 10px; font-weight: 600; white-space: nowrap; opacity: 1; transition: opacity 0.3s; }
        .cr-bubble::after { content: ''; position: absolute; bottom: -4px; left: 50%; width: 6px; height: 6px; background: #fff; border-right: 1px solid var(--cr-primary); border-bottom: 1px solid var(--cr-primary); transform: translateX(-50%) rotate(45deg); }

        /* States */
        .cr-node.is-hidden { opacity: 0; visibility: hidden; transform: translate(-50%, -20%) scale(0.8); }
        .cr-node.is-locked .cr-icon { background: #E0E0E0; box-shadow: none; border-color: #fff; }
        .cr-node.is-locked .cr-bubble { opacity: 0.5; border-color: #ccc; }
        .cr-node.is-locked .cr-bubble::after { border-color: #ccc; }
        .cr-node.is-active .cr-icon { transform: scale(1.2); }
        ._successAnimation_vjous_1 {
            position: absolute;
            z-index: 0;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            display:block !important;
        }
      </style>

      <div class="cr-header">
        <p class="cr-msg">Loading...</p>
      </div>
      <div class="cr-track">
        <div class="cr-bg"></div>
        <div class="cr-fill"><div class="cr-glow"></div></div>
        ${nodesHtml}
      </div>
      <div class="_successAnimation_vjous_1" style="background-image: url(&quot;https://front.myshopline.com/cdn/v1/plugin/app-code-block/sale/cart-upsell-plugin/2025122303113939/assets/successAnimation.c873f731.gif?key=1770106395863&quot;);"></div>
    `;

    // 缓存节点
    this.dom = {
      fill: this.querySelector('.cr-fill'),
      msg: this.querySelector('.cr-msg'),
      nodes: this.querySelectorAll('.cr-node')
    };
  }

  updateUI(count) {
    if (!this.dom) return;
    count = parseInt(count) || 0;

    // 1. 进度条宽度
    let pct = (count / this.maxScale) * 100;
    if (pct > 100) pct = 100;
    if (count > 0 && pct < 2) pct = 2; // 最小宽度
    this.dom.fill.style.width = `${pct}%`;

    // 2. 节点状态循环 (Loop Logic)
    let nextTarget = null;

    this.dom.nodes.forEach((node, index) => {
      const targetQty = parseInt(node.dataset.q);
      
      // A. 解锁显示逻辑 (Visibility)
      // 规则：Tier 0 始终显示。
      // Tier N 显示，如果 Tier N-1 已达成。
      let shouldShow = false;
      if (index === 0) {
        shouldShow = true;
      } else {
        const prevTarget = this.tiers[index - 1].q;
        if (count >= prevTarget) shouldShow = true;
      }

      if (shouldShow) {
        node.classList.remove('is-hidden');
      } else {
        node.classList.add('is-hidden');
      }

      // B. 激活状态逻辑 (Active/Locked)
      if (count >= targetQty) {
        node.classList.remove('is-locked');
        node.classList.add('is-active');
      } else {
        node.classList.add('is-locked');
        node.classList.remove('is-active');
        
        // 找到第一个未达成的目标，作为 "Next Target"
        if (!nextTarget && shouldShow) {
          nextTarget = this.tiers[index];
        }
      }
    });

    // 3. 动态文案
    let html = '';
    if (!nextTarget) {
      // 如果没有下一个目标，说明全部达成 (或者所有显示的都达成了)
      // 检查是否真的到了最后一个
      const lastTier = this.tiers[this.tiers.length - 1];
      if (count >= lastTier.q) {
        html = this.msgs.done;
      } else {
        // 这种情况理论上少见，但也可能存在（比如还没解锁下一个）
        // 默认取下一个未解锁的
        const nextHidden = this.tiers.find(t => t.q > count);
        if(nextHidden) {
           let diff = nextHidden.q - count;
           html = this.msgs.progress
            .replace('[diff]', `<span class="cr-bold">${diff}</span>`)
            .replace('[next_label]', `<span class="cr-bold">${nextHidden.l}</span>`);
        }
      }
    } else {
      let diff = nextTarget.q - count;
      html = this.msgs.progress
        .replace('[diff]', `<span class="cr-bold">${diff}</span>`)
        .replace('[next_label]', `<span class="cr-bold">${nextTarget.l}</span>`);
    }
    
    this.dom.msg.innerHTML = html;
  }

  fetchCart() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(r => r.json())
      .then(c => this.updateUI(c.item_count))
      .catch(e => console.error(e));
  }

  handleUpdate(e) {
    if (e.detail && typeof e.detail.item_count !== 'undefined') {
      this.updateUI(e.detail.item_count);
    } else {
      this.fetchCart();
    }
  }
}

customElements.define('cart-rewards-bar', CartRewardsBar);

// 全局 Fetch 拦截器 (保持单例)
(function() {
  if (window.CartRewardsInterceptorAttached) return;
  window.CartRewardsInterceptorAttached = true;
  const dispatchUpdate = () => window.dispatchEvent(new CustomEvent('cart:updated'));
  
  const originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then((res) => {
      if (res.url.includes('/cart/add') || res.url.includes('/cart/change') || res.url.includes('/cart/update')) {
        setTimeout(dispatchUpdate, 200);
      }
      return res;
    });
  };
})();